import { SurveyElement } from './element';
import { Expose, Type } from 'class-transformer';
import { SurveySingleSelectElementOptions } from './single-select-element-options';
import { SINGLE_SELECT_TYPE } from '@/models/enums/single-select-type';
export class SurveySingleSelectElement extends SurveyElement {
  @Expose({ name: 'question' })
  title!: string;

  @Expose()
  type!: SINGLE_SELECT_TYPE;

  @Expose()
  @Type(() => SurveySingleSelectElementOptions)
  options!: SurveySingleSelectElementOptions[];

  @Expose()
  icon?: string;
}
